exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clear{color:gray\n}\ni:hover:before{height:42px;color:#ff1493\n}\n.criteria{font-size:small\n}\n.criteria .button{color:gray\n}\n#loading{background:rgba(255,255,255,.6);position:fixed;height:100vh;width:100vw;z-index:10010;top:0;left:0;text-align:center\n}\n#loading i{Position:absolute;Top:50%;Transform:translateY(-50%)\n}\n.no-border{border:0\n}\n.wrapper{position:relative\n}\n.wrapper span.fas{position:absolute;top:20px;left:20px;color:#fff;box-shadow:0 0 5px 5px #000\n}\n.agent_name{text-align:center;color:#000\n}", ""]);

// exports
